export const EmergencyDisconnectReason = 'Emergency Disconnect';
